import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Container from '../../components/Container';
import {Grid, ListItem, Box, IconButton} from '@material-ui/core'
import Typography from '../../components/CustomTypo'
import {LogoutIcon, AddIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import TermAndConditions from './TermAndConditions'
const styles = theme => ({

    cursor:{
        cursor: 'pointer'
    },
    listItem:{
        padding: theme.spacing(4)
    },
    marginTop:{
        marginTop: theme.spacing(4)
    },
    box: {
        backgroundColor:theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1,4,1,4),
        cursor: 'pointer'
    },

});
function ParticipatingSchemesView(props) {
    const { classes, t,onClose, showLoading, joinedSchemes, onSignOutScheme, availableSchemes, onShowTermAndCondition, showTermAndCondition } = props;
    //console.log("wallet_info:", this.props.wallet_info);

    return (
        <DrawerCustom 
            open={props.open} 
            onClose = {()=>onClose('participating_schemes')}
            enableBack
            title = {t('participating_schemes')} 
            children={<ParticipatingSchemes classes={classes} t={t} onClose={onClose}
                            showLoading={showLoading}
                            joinedSchemes = {joinedSchemes}
                            onSignOutScheme={onSignOutScheme}
                            availableSchemes={availableSchemes}
                            onShowTermAndCondition={onShowTermAndCondition}
                            showTermAndCondition={showTermAndCondition}/>}/>
    );
}
function ParticipatingSchemes(props){
    const { classes, t, showLoading, joinedSchemes, onSignOutScheme, availableSchemes, onShowTermAndCondition, showTermAndCondition, onRegister, itemToBeJoin } = props;
    return(
        <Grid item>
                <Grid item container className={classes.box}>
                    <Grid xs={12} item >
                        <Typography mg_top_xs variant='h6'>{t('participate_in')}</Typography>
                    </Grid>
                    <Grid xs={12} item>
                        {joinedSchemes&&joinedSchemes.map((item, index) => {
                                                return (
                                                    <ListItem key={index} className={classes.listItem}>
                                                        <Grid xs={10} item container justify='flex-start'>
                                                            <Typography variant='body1'>{item.name}</Typography>
                                                        </Grid>
                                                        <Grid xs={12} item container justify='flex-end'> 
                                                            {item.sign_up_option != "AUTO_SIGN_UP" && <IconButton onClick={() => onSignOutScheme(item)}>
                                                                <LogoutIcon />
                                                            </IconButton>}
                                                        </Grid>
                                                    </ListItem>
                                                )
                                            })}
                    </Grid>
                </Grid>
            <Grid item className={classes.marginTop}>
                <Grid item className={classes.box}>
                    <Grid xs={12} item>
                        <Typography  variant='h6'>{t('join_more_schemes')}</Typography>
                    </Grid>
                    <Grid xs={12} item>
                    {availableSchemes&&availableSchemes.map((item, index) => {
                                            return (
                                                <ListItem key={index} className={classes.listItem} onClick={() =>onShowTermAndCondition(item)} className={classes.cursor}>
                                                    <AddIcon /><Typography color='progress' variant='body1'>{item.name}</Typography>
                                                </ListItem>
                                            )
                                        })}
                    </Grid>
                </Grid>
            </Grid>
            {showLoading?<Grid xs={12} item container justify='center'><CustomizedCircularProgress/></Grid>:null}
        </Grid>
    )

}

export default withStyles(styles)(withTranslation()(ParticipatingSchemesView));